<template>
  <Disclaimer :slice="slices[0]" />
</template>

<script>
import { Disclaimer } from './components'

export default {
  components: {
    Disclaimer,
  },
  props: {
    slices: {
      type: Array,
      default: () => [{}],
    },
  },
}
</script>
